import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  bottom: 2px;
  right: 1px;
  padding: 3px 10px;
  background-color: gold;
  color: #333;
  font-size: 12px;
  border-radius: 10px 0 0 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;
